export enum EProductCustomAttributes {
  Description = 'description',
  TechnologyDescription = 'tecnology_description',
  TechnicalSpecificationsDescription = 'technical_specifications_description',
  TechnicalSpecificationsTable = 'technical_specifications_table',
  TechnicalDetailsImage = 'technical_details_image',
  TechnicalDetailsDescription = 'technical_details_description',
  TechnologyImage = 'tecnology_image',
  UrlPdp = 'url_pdp',
  DescriptionGpd = 'descricao_gpd'
}
